import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {InputDate} from '@/components/commons/input-date/InputDate'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {suspendReasonToLabel} from '../../utils'
import {TextArea} from '@/components/commons/textarea/TextArea'
import {NOTES_MAX_LENGTH} from '../../formSchemas'

export const ProjectOptionsSuspendFields = () => {
    const {t} = useTranslation()
    const {control} = useFormContext()
    const suspensionStartDate = useWatch({control, name: 'suspensionStartDate'})
    const suspensionEndDate = useWatch({control, name: 'suspensionEndDate'})

    return (
        <Flexbox direction="column" fullWidth gap={4}>
            <Flexbox gap={2}>
                <Controller
                    control={control}
                    name="suspensionStartDate"
                    render={({field, fieldState}) => (
                        <InputDate
                            label={t('projects:suspend_start_date')}
                            placeholder={'GG/MM/AAAA'}
                            errorMessage={fieldState.error?.message}
                            disableAfterDate={suspensionEndDate ? new Date(suspensionEndDate) : undefined}
                            fullWidth
                            {...field}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name="suspensionEndDate"
                    render={({field, fieldState}) => (
                        <InputDate
                            label={t('projects:suspend_end_date')}
                            placeholder={'GG/MM/AAAA'}
                            isOptional
                            errorMessage={fieldState.error?.message}
                            disableBeforeDate={suspensionStartDate ? new Date(suspensionStartDate) : undefined}
                            fullWidth
                            {...field}
                        />
                    )}
                />
            </Flexbox>
            <Controller
                control={control}
                name="suspensionReason"
                render={({field, fieldState}) => (
                    <InputSelect
                        label={t('projects:suspend_reason')}
                        optionsMap={suspendReasonToLabel}
                        errorMessage={fieldState.error?.message}
                        {...field}
                    />
                )}
            />
            <Controller
                control={control}
                name="suspensionNotes"
                render={({field, fieldState}) => (
                    <TextArea
                        label={t('commons:notes')}
                        errorMessage={fieldState.error?.message}
                        maxLength={NOTES_MAX_LENGTH}
                        placeholder={t('commons:notes_placeholder')}
                        helpText={`${field.value?.length ?? 0}/${NOTES_MAX_LENGTH}`}
                        {...field}
                    />
                )}
            />
        </Flexbox>
    )
}
